<template>
  <div class="edit-motivators part-content">
    <h4 v-translate class="heading-4">Motivators (optional)</h4>
    <form @submit.prevent>
      <b-field :label="labels.fieldLabel" class="form-field">
        <multiselect-field v-if="profileOptionsState.leave_reasons"
                           :placeholder="placeholder"
                           :options="profileOptionsState.leave_reasons"
                           :value="motivatorsListState"
                           :taggable="false"
                           :multiple="true"
                           :iconField="true"
                           :close-on-select="false"
                           :clear-on-select="true"
                           :show-options-list="searchable"
                           :showLabels="false"
                           :big-input-font-size="true"
                           :searchable="searchable"
                           :show-no-results="searchable"
                           label="name"
                           track-by="slug"
                           @select="addMotivatorItemState($event); setHasChanges(true)"
                           @remove="removeMotivatorItemState($event); setHasChanges(true)">
          <template slot="multiselect-icon">
            <div class="tag-icon">
              <svg-icon name="search" width="16" height="16"></svg-icon>
            </div>
          </template>
        </multiselect-field>
      </b-field>
    </form>
  </div>
</template>

<script>

import 'top20common/distribution/icons/search';

import MultiselectField from 'top20common/components/MultiselectField';
import {mapGetters, mapMutations} from 'vuex';

export default {
  mounted() {
    this.$emit('form-filled', this.motivatorsHasValuesState);
  },
  watch: {
    motivatorsHasValuesState(newValue) {
      this.$emit('form-filled', newValue);
    }
  },
  computed: {
    ...mapGetters(['motivatorsListState', 'profileOptionsState', 'motivatorsHasValuesState', 'partHasChangesState']),
    labels() {
      return {
        fieldLabel: this.$gettext('Top 3 things you look for in a new job')
      };
    },
    searchable() {
      return this.motivatorsListState.length < 3;
    },
    placeholder() {
      return this.searchable ? this.$gettext('Select option') : '';
    }
  },
  methods: {
    ...mapMutations(['removeMotivatorItemState', 'addMotivatorItemState']),
    saveMotivators(data) {
      return this.$store
        .dispatch('saveMotivatorsAction', data)
        .then(() => {
          this.$toast.open({message: this.$gettext('Motivators saved'), type: 'is-success'});
        })
        .catch(() => {
          this.$toast.open({message: this.$gettext('Motivators not saved'), type: 'is-danger'});
        });
    },
    save() {
      return new Promise((resolve, reject) => {
        if (this.partHasChangesState.motivators) {
          this.saveMotivators([...this.motivatorsListState])
            .then(resolve)
            .catch(reject);
        } else {
          resolve();
        }
        this.setHasChanges(false);
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        return resolve();
      });
    },
    setHasChanges(value) {
      this.$store.commit('mutatePartHasChangesState', {motivators: value});
    }
  },
  components: {MultiselectField}
};
</script>

<style lang="scss" scoped>
.form-field {
  margin-top: 20px;
  .input {
    margin-top: 5px;
  }
  /deep/ .svg-icon {
    fill: var(--gray);
  }
}

/deep/ .multiselect--active span.multiselect__single {
  max-height: 20px;
}
</style>
